import update from "immutability-helper";

function getId(s) {
    return s.toLowerCase().replace(/[^a-z]/g, "_");
}

export default function getReducer(days, items, blockedDays, defaultState) {
    const DayTemplate = items.map(i => {
        return [
            getId(i.name)
        ].concat(
            i.extras.map(
                e => getId(i.name) + "_" + getId(e.name)
            )
        )
    }).reduce((a, b) => a.concat(b), []).reduce((a, b) => {
        a[b] = defaultState;
        return a;
    }, {});

    const initialState = {
        term: {},
        children: 1,
        isMobile: false, // window.innerWidth < 500,
        blockedDays: blockedDays.map( b => ({ from: new Date(b.from), to: new Date(b.to), desc: b.desc })),
        days: days.reduce((a, day) => {
            a[day] = JSON.parse(JSON.stringify(DayTemplate));
            return a;
        }, {}),
        items: items.map(i => {
            i.id = getId(i.name)
            i.extras = i.extras.map(
                e => {
                    e.id = getId(i.name) + "_" + getId(e.name)
                    return e;
                }
            );
            return i;
        }),
        includeInsurance: false
    }

    return function reducer(state = initialState, action) {
        switch (action.type) {
            // case "SETMOBILE": //Set if mobile view
            //     return update(state, { isMobile: { $set: action.isMobile } });
            //     break;
            case "SETCHILDREN": //Set no. of children
                return update(state, { children: { $set: action.children } });
            case "SETTERM": //Set open term group
                return update(state, { 
                    term: { [action.id]: { $set: !state.term[action.id] } },

                    days: {
                        $apply: days => {
                            if(!state.term[action.id]){ //Short out if setting true
                                return days;
                            }
                            let out = {};
                            Object.keys(days).forEach( date =>{
                                //Set up for modes
                                if( action.days.indexOf(date) != -1 ){ //Set to false only if matched
                                    out[date] = {};
                                    Object.keys(days[date]).forEach( m =>{ //Set the modes based on if date in action
                                        
                                        out[date][m] = false;
                                    });
                                }                                    
                            })
                            return Object.assign({}, days, out);
                        }
                    }
                
                });
            case "SETDAY": //Set wether a particular day/type is active, with option to clear any other types with matching prefix.
                return update(state, {
                    days: {
                        [action.day]: {
                            $apply: modes => { //Since we need to support changing prefixes, we use an $apply here instead of $set
                                let m = Object.assign({}, modes);
                                if (action.clearPrefix) {
                                    Object.keys(m).filter(k => k.indexOf(action.mode) == 0).forEach(k => {
                                        m[k] = action.value;
                                    })
                                } else {
                                    m[action.mode] = action.value;
                                }
                                return m;
                            }
                        }
                    }
                });
            case "SETDAYS":
                // {days:[] } Days to set to true
                return update(state, {
                    days: {
                        $apply: days => {
                            let out = {};
                            Object.keys(days).forEach( date =>{
                                //Set up for modes
                                if(action.days.indexOf(date) !== -1){
                                    out[date] = {};
                                    Object.keys(days[date]).forEach( m =>{ //Set the modes based on if date in action
                                        out[date][m] = true
                                    });
                                }
                            })
                            return Object.assign({}, days, out);
                        }
                    }
                });
            case "SETINSURANCE": 
                return update(state, { includeInsurance: { $set: action.insurance } })
        }
        return state;
    }
}


// WEBPACK FOOTER //
// ./flexi/store/reducer.js